/** Upload rules shared by the browser (instant feedback) and the API (authoritative), DOC-02. */

export const EXT_TYPE: Record<string, string> = {
  pdf: 'application/pdf',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
};

export function formatBytes(n: number): string {
  if (n >= 1024 * 1024) return `${(n / 1024 / 1024).toFixed(n >= 10 * 1024 * 1024 ? 0 : 1)} MB`;
  return `${Math.max(1, Math.round(n / 1024))} KB`;
}

/** The rejection the patient sees names the file and the rule (DOC-02). */
export function rejectionFor(
  filename: string,
  sizeBytes: number,
  contentType: string,
  rules: { maxBytes: number; types: readonly string[] },
): string | null {
  const ext = filename.split('.').pop()?.toLowerCase() ?? '';
  const type = rules.types.includes(contentType) ? contentType : EXT_TYPE[ext];
  if (!type || !rules.types.includes(type)) {
    const shown = ext ? ext.toUpperCase() : 'These';
    return `Not added. ${shown} files aren't accepted. Save the report as a PDF, or photograph the pages as JPG.`;
  }
  if (sizeBytes > rules.maxBytes) {
    return `Not added. ${filename} is ${formatBytes(sizeBytes)}; the limit is ${formatBytes(rules.maxBytes)} each.`;
  }
  return null;
}

/** "PDF", "JPG", "PNG": the label on a file icon. */
export function fileLabel(filename: string, contentType: string): string {
  if (contentType === 'application/pdf') return 'PDF';
  if (contentType === 'image/jpeg') return 'JPG';
  if (contentType === 'image/png') return 'PNG';
  return (filename.split('.').pop() ?? 'FILE').slice(0, 4).toUpperCase();
}
